import { dataHooks } from '../../../../libs/dataHooks';

export const subTitleDataHooks = dataHooks<{
  title: {};
}>('sub-title');
